// 设置阿拉伯语镜像显示
const setArabicMirror = () => {
  try {
    const userSelected = theme.getCookies("userSelected");
    if (!userSelected) return;

    // 尝试解析 cookie 值（假设是 JSON 格式）
    const userConfig = JSON.parse(userSelected);

    if (userConfig.language === "ar") {
      // 设置文档方向为从右到左
      document.documentElement.dir = "rtl";
      document.body.dir = "rtl";

      // 添加阿拉伯语样式
      const style = document.createElement("style");
      style.textContent = `
        /* 全局镜像样式 */
        body {
          direction: rtl;
          text-align: right;
        }
        
        /* 修正 float */
        .float-left {
          float: right !important;
        }
        .float-right {
          float: left !important;
        }
        
        /* 修正 flex 布局 */
        .flex-row {
          flex-direction: row-reverse !important;
        }
        
        /* 修正文本对齐 */
        .text-left {
          text-align: right !important;
        }
        .text-right {
          text-align: left !important;
        }
        input {
          text-align: right!important;
        }
      `;
      document.head.appendChild(style);
      document.body.classList.add("mirror");
    }
  } catch (error) {
    console.error("设置阿拉伯语镜像显示时出错：", error);
  }
};

window.addEventListener("DOMContentLoaded", setArabicMirror);
